/**
 * Upload helper with hints
 */
import $ from 'jquery';

$(function () {
    "use strict";
    applyEventHooks();
});

function applyEventHooks() {
    "use strict";
    /* Upload validation */
    if ($('.upload-hints').length > 0 && $('.upload-validation').length > 0) {
        $('.upload-validation').on('change', function (e) {
            // Reset validation status
            $(this).removeClass('is-invalid');

            // Reset file count hints
            if ($('#file_count').length > 0) {
                $('#file_count').addClass('text-danger');
                $('#file_count i').addClass('fa-times');
                $('#file_count').removeClass('text-success');
                $('#file_count i').removeClass('fa-check');
                $('#file_count .visually-hidden').html('⚠️');
            }

            // Reset filetype hints
            if ($('#file_type').length > 0) {
                $('#file_type').addClass('text-danger');
                $('#file_type i').addClass('fa-times');
                $('#file_type').removeClass('text-success');
                $('#file_type i').removeClass('fa-check');
                $('#file_type .visually-hidden').html('⚠️');
            }

            // Reset filesize hints
            if ($('#file_size').length > 0) {
                $('#file_size').addClass('text-danger');
                $('#file_size i').addClass('fa-times');
                $('#file_size').removeClass('text-success');
                $('#file_size i').removeClass('fa-check');
                $('#file_size .visually-hidden').html('⚠️');
            }

            // Get files
            let files = e.target.files;

            // Defaults
            let isInvalid = false;
            let errorType = 0;
            let errorSize = 0;
            let maxCount = $(this).data('maxcount');
            let maxSize = $(this).data('maxsize');
            let accept = $(this).attr('accept');
            let hideHints = $(this).data('hidehints');

            if ($('#file_count').length > 0) {
                if (files.length <= maxCount) {
                    $('#file_count').removeClass('text-danger');
                    $('#file_count i').removeClass('fa-times');
                    $('#file_count').addClass('text-success');
                    $('#file_count i').addClass('fa-check');
                    $('#file_count .visually-hidden').html('✔');
                } else {
                    isInvalid = true;
                }
            }

            if (files.length > 0) {
                // Loop through files
                for (let file of files) {
                    if (file) {
                        // Check file size
                        if (maxSize != undefined && maxSize != '') {
                            if (file.size != undefined && file.size > maxSize) {
                                errorSize++;
                                isInvalid = true;
                            }
                        }

                        // Only if we have a type
                        if (accept != undefined && accept != '') {
                            let types = accept.split(',');
                            let nameExtension = file.name.split('.').pop();

                            if (nameExtension != undefined && types.includes('.' + nameExtension) === false) {
                                errorType++;
                                isInvalid = true;
                            }
                        }
                    }
                }

                if ($('#file_type').length > 0) {
                    if (errorType <= 0) {
                        $('#file_type').removeClass('text-danger');
                        $('#file_type i').removeClass('fa-times');
                        $('#file_type').addClass('text-success');
                        $('#file_type i').addClass('fa-check');
                        $('#file_type .visually-hidden').html('✔');
                    }
                }

                if ($('#file_size').length > 0) {
                    if (errorSize <= 0) {
                        $('#file_size').removeClass('text-danger');
                        $('#file_size i').removeClass('fa-times');
                        $('#file_size').addClass('text-success');
                        $('#file_size i').addClass('fa-check');
                        $('#file_size .visually-hidden').html('✔');
                    }
                }
            }

            // Hide hints
            if (hideHints != undefined && hideHints != '' && $('.upload-hints').hasClass('d-none') == false) {
                $('.upload-hints').addClass('d-none');
            }

            // Set form invalid
            if (isInvalid) {
                $(this).addClass('is-invalid');
                $('.upload-hints').removeClass('d-none');
            }
        });
    }

    /* Image upload with validation and preview */
    if($('.preview').length > 0 && $('.preview-input').length > 0) {
        $('.preview-input').on('change', function(e) {
            // Reset validation status
            $(this).removeClass('is-invalid');

            // Reset image size hints
            if ($('#image_size').length > 0) {
                $('#image_size').addClass('text-danger');
                $('#image_size i').addClass('fa-times');
                $('#image_size').removeClass('text-success');
                $('#image_size i').removeClass('fa-check');
                $('#image_size .visually-hidden').html('⚠️');
            }

            // Reset image type hints
            if ($('#image_type').length > 0) {
                $('#image_type').addClass('text-danger');
                $('#image_type i').addClass('fa-times');
                $('#image_type').removeClass('text-success');
                $('#image_type i').removeClass('fa-check');
                $('#image_type .visually-hidden').html('⚠️');
            }

            // Reset image height hints
            if ($('#image_height').length > 0) {
                $('#image_height').addClass('text-danger');
                $('#image_height i').addClass('fa-times');
                $('#image_height').removeClass('text-success');
                $('#image_height i').removeClass('fa-check');
                $('#image_height .visually-hidden').html('⚠️');
            }

            // Reset image width hints
            if ($('#image_width').length > 0) {
                $('#image_width').addClass('text-danger');
                $('#image_width i').addClass('fa-times');
                $('#image_width').removeClass('text-success');
                $('#image_width i').removeClass('fa-check');
                $('#image_width .visually-hidden').html('⚠️');
            }

            // Get files
            let file = $(this).get(0).files[0];

            let isInvalid = false;
            let minHeight = $(this).data('minheight');
            let maxHeight = $(this).data('maxheight');
            let minWidth = $(this).data('minwidth');
            let maxWidth = $(this).data('maxwidth');
            let maxSize = $(this).data('maxsize');
            let accept = $(this).attr('accept');

            if(file){
                if(maxSize != undefined && maxSize != '' && $('#image_size').length > 0){
                    if (file.size != undefined && file.size > maxSize) {
                        isInvalid = true;
                    } else {
                        $('#image_size').removeClass('text-danger');
                        $('#image_size i').removeClass('fa-times');
                        $('#image_size').addClass('text-success');
                        $('#image_size i').addClass('fa-check');
                        $('#image_size .visually-hidden').html('✔');
                    }
                }

                var reader = new FileReader();

                reader.onload = function(){
                    // Only if we have a type
                    if(accept != undefined && accept != '' && $('#image_type').length > 0){
                        var types = accept.split(',');
                        if(file['type'] != undefined && $.inArray(file['type'], types) < 0) {
                            $('.preview').attr('src', $('.preview').data('org'));
                            isInvalid = true;
                        } else {
                            $('#image_type').removeClass('text-danger');
                            $('#image_type i').removeClass('fa-times');
                            $('#image_type').addClass('text-success');
                            $('#image_type i').addClass('fa-check');
                            $('#image_type .visually-hidden').html('✔');
                            $('.preview').attr('src', reader.result);
                        }
                    }

                    var image = new Image();

                    image.src = reader.result;

                    image.onerror = function() {
                        if ($('#image_height').length > 0) {
                            isInvalid = true;
                        }

                        if ($('#image_width').length > 0) {
                            isInvalid = true;
                        }
                    }

                    image.onload = function () {
                        if(minHeight != undefined && minHeight != '' && maxHeight != undefined && maxHeight != '' && $('#image_height').length > 0) {
                            if (this.height < minHeight || this.height > maxHeight) {
                                isInvalid = true;
                            } else {
                                $('#image_height').removeClass('text-danger');
                                $('#image_height i').removeClass('fa-times');
                                $('#image_height').addClass('text-success');
                                $('#image_height i').addClass('fa-check');
                                $('#image_height .visually-hidden').html('✔');
                            }
                        }
                        if(minWidth != undefined && minWidth != '' && maxWidth != undefined && maxWidth != '' && $('#image_width').length > 0) {
                            if (this.width < minWidth || this.width > maxWidth) {
                                isInvalid = true;
                            } else {
                                $('#image_width').removeClass('text-danger');
                                $('#image_width i').removeClass('fa-times');
                                $('#image_width').addClass('text-success');
                                $('#image_width i').addClass('fa-check');
                                $('#image_width .visually-hidden').html('✔');
                            }
                        }
                    }
                }

                reader.readAsDataURL(file);
            }

            // Set form invalid
            if (isInvalid) {
                $(this).addClass('is-invalid');
            }
        });
    }
}

window.uploadHelper = {
    applyEventHooks: applyEventHooks,
};
